import {VuexModule, Module, Mutation, Action, getModule} from 'vuex-module-decorators'
import store from '@/store'

export interface IErrorAlertState {
  errorAlert: string;
}

@Module({dynamic: true, store, name: 'errors'})
class ErrorAlert extends VuexModule implements IErrorAlertState {

    errorAlert = '';
    isErrorXml = false;

    @Mutation
    SET_ERROR_ALERT(data: string) {
        this.errorAlert = data ? data : '';
    }

    @Mutation
    IS_ERROR_XML(data: boolean) {
        this.isErrorXml = data;
    }

    @Action
    public setErrorAlert(data: string) {
        this.SET_ERROR_ALERT(data);
        this.IS_ERROR_XML(false);
    }

    @Action
    public setErrorAlertXml(data: string) {
        this.SET_ERROR_ALERT(data);
        this.IS_ERROR_XML(!!data);
    }


}

export const ErrorAlertModule = getModule(ErrorAlert)
